import PropTypes from 'prop-types';
import React, {createContext, useContext} from 'react';
// import {useAppShellContext} from './AppShellContext';
 
const FeatureFlagContext = createContext()
 
function useFeatureFlags() {
  return useContext(FeatureFlagContext);
}
 
const FeatureFlagProvider = ({ children }) => {
  // const {config} = useAppShellContext()
  // const {featureFlags: envFeatureFlags} = config
 
  // const isFeatureFlagOn = featureFlagValue => ['true', 'on'].includes(featureFlagValue?.toLowerCase());
 
  // const snakeCaseToCamelCase = s => s.toLowerCase()
  //   .replace(/([-_][a-z])/g, group =>
  //     group
  //       .toUpperCase()
  //       .replace('-', '')
  //       .replace('_', '')
  //   )
  const featureFlags = true; // Object.fromEntries(
  //   Object.entries(envFeatureFlags).map(([k, v]) =>
  //     [snakeCaseToCamelCase(k.startsWith('FF_') ? k.substring(3) : k), isFeatureFlagOn(v)]))
 
  const featureFlagChecker = {
    isActive: (s) => {
      if (featureFlags[s] === undefined) {
        // eslint-disable-next-line no-console
        console.warn(`queried for an unknown feature flag: ${s}`)
      }
      return featureFlags[s] === true
    },
    isInactive: (s) => !featureFlagChecker.isActive(s)
  }
  return (
    <FeatureFlagContext.Provider value={featureFlagChecker}>
      {children}
    </FeatureFlagContext.Provider>
  );
}
 
FeatureFlagProvider.propTypes = {
  children: PropTypes.node
}
 
export {FeatureFlagProvider, useFeatureFlags}